import {ProductInterface} from '__generated__/__types__';

export const isProductInStock = (product: ProductInterface) => {
    return product?.stock_status === 'IN_STOCK';
};
